export enum AccountTransferFailedReason {
  NOT_ENOUGH_BALANCE = 'NOT_ENOUGH_BALANCE',
  BALANCE_NOT_FOUND = 'BALANCE_NOT_FOUND'
}

export enum AccountTransferStatus {
  CREATED = 'CREATED',
  FAILED = 'FAILED',
  TRANSFERED = 'TRANSFERED'
}
